import React, { useEffect, useState } from "react";
import "./TransactionHistory.css";
import { transactionListApi } from "../../../../services/profile";
import { toastMessage } from "../../../../utils/toastMessage";
import { dateFormatWithTime } from "../../../../utils/dateTimeFormat";
import FlatList from "components/FlatList";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import Skeleton from "react-loading-skeleton";

const TransactionHistory = () => {
  const [transactionList, setTransactionList] = useState([]);
  const [loader, setLoader] = useState(true);

  //----------file-download---------------
  const handleFile = (data) => {
    if (data?.status === "SUCCESS" && data?.invoiceHostedUrl) {
      window.open(data.invoiceHostedUrl, "_blank");
    } else {
      console.log("No valid URL to open.");
    }
  };

  //-------handle-color-price----------
  const colorHandler = (data) => {
    if (data?.status === "SUCCESS") {
      return "program-price text-success";
    } else if (data?.status === "FAILED") {
      return "program-price text-danger";
    } else {
      return "program-price text-default";
    }
  };
  //-------handle-cursor-----------
  const cursorHandler = (data) => {
    if (data?.status === "SUCCESS") {
      return "program-item cursor-pointer";
    } else {
      return "program-item";
    }
  };

  //--------transaction-list-------------
  useEffect(() => {
    const transactionList = async () => {
      try {
        setLoader(true);
        const { data } = await transactionListApi({ pagination: true });
        const { success, message, data: response } = data;
        if (success) {
          setTransactionList(response || []);
        } else {
          toastMessage(message, "error", "fetchTransaction");
        }
      } catch (e) {
        console.log("Error:-", e.message);
      } finally {
        setLoader(false);
      }
    };
    transactionList();
  }, []);

  return (
    <>
      <div className="transaction_history">
        <h3 className="profile_title">Transaction history</h3>
        <div className="program-list">
          <FlatList
            data={transactionList}
            renderItem={(data) => {
              return (
                <div
                  key={data._id}
                  className={cursorHandler(data)}
                  onClick={() => handleFile(data)}
                >
                  <img
                    src={data?.group?.coverImage || ""}
                    alt={data?.group?.name}
                    className="program-image"
                  />
                  <div className="program-details">
                    <h3>{data?.group?.name || "N/A"}</h3>
                    <p>{dateFormatWithTime(data?.createdAt)}</p>
                  </div>
                  <p className={colorHandler(data)}>
                    {data?.currency} {data?.price || "N/A"}
                  </p>
                </div>
              );
            }}
            loading={loader}
            loadingItem={(it) => {
              return (
                <div key={it} className="program-item">
                  <Skeleton
                    className="program-image"
                    containerClassName="program-image"
                  />
                  <div className="program-details">
                    <Skeleton containerClassName="w-100" count={1.5} />
                  </div>
                </div>
              );
            }}
            placeholder={
              <NotFoundPlaceHolder title="No Transaction History Available" />
            }
          />
        </div>
      </div>
    </>
  );
};

export default TransactionHistory;
